'use strict';
const dataPlaceholders = {"DEFAULT_ANALYTICS_SUBMIT_EVENTS_URL":"https://analytics-fe.digital-cloud-uk.medallia.eu/api/web/events","USER_AGENT_CLIENT_HINTS_LIST":"[\"brands\", \"mobile\", \"platform\", \"architecture\", \"model\", \"bitness\", \"platformVersion\", \"fullVersionList\", \"wow64\", \"uaFullVersion\"]","DIGITAL_ANALYTICS_STATIC_EVENTS_LIST":"[]","ONSITE_DATA_PATH":"resources.digital-cloud-uk.medallia.eu/wdcuk/139686/onsite/onsiteData1789467357371.json","SUBMIT_URL_PREFIX":"https://feedback.digital-cloud-uk.medallia.eu/","JS_SITE_CODE":"resources.digital-cloud-uk.medallia.eu/wdcuk/139686/onsite/generic1789467302081.js","DEFAULT_MEC_INTEGRATION_ID":"zurich-lon-medallia-com-zurich","USERSNAP_HOST_PREFIX":"//screencapture.kampyle.com/","COOLADATA_API_HOST":"udc-neb.kampyle.com/","COOLADATA_SRC_PREFIX":"https://resources.digital-cloud-uk.medallia.eu/","ONSITE_VERSION":"1.72.1","USERSNAP_V4_HOST_PREFIX":"//scp.kampyle.com","URL_PREFIX":"https://resources.digital-cloud-uk.medallia.eu/","USERSNAP_ONPREM_HOST_PREFIX":"https://md-scp.kampyle.com/"};
const modulesConfig = {"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false};

if (!window.KAMPYLE_EMBED) {
  if (modulesConfig.isOnPremEnabled) {
    var onPremEmbedRegex = /\/[a-zA-Z\d-]+\/\d+\/onsite\/medallia-digital-embed\.js$/;
    var genericPathRegex = /\/[a-zA-Z\d-]+\/\d+\/onsite\/generic\d{13}\.js$/;
    var onsiteDataPathRegex = /\/[a-zA-Z\d-]+\/\d+\/onsite\/onsiteData\d{13}\.json$/;
  }
  function getSafeProperty(obj, pathString) {
    if (typeof pathString !== 'string' || !pathString) {
      return undefined;
    }
    var props = pathString.split('.');
    var current = obj;
    var i;
    var key;

    for (i = 0; i < props.length; i++) {
      key = props[i];
      if (
          !key ||
          key === '__proto__' ||
          key === 'prototype' ||
          key === 'constructor' ||
          current == null ||
          (typeof current !== 'object' && typeof current !== 'function') ||
          !Object.prototype.hasOwnProperty.call(current, key)
      ) {
        return undefined;
      }
      current = current[key];
    }
    return current;
  }
  function getCspNonce(noncePath) {
    var nonce = getSafeProperty(window, noncePath);
    if (typeof nonce !== 'string' || !nonce) {
      console.warn('KAMPYLE_EMBED: Nonce value is not found!');
      return undefined;
    }
    return nonce;
  }

  window.KAMPYLE_EMBED = {
    kampyleInit: function () {
      var t = document.createElement('script');
      t.type = 'text/javascript';
      t.async = true;
      t.src = KAMPYLE_EMBED.getGenericLocation();
      if (dataPlaceholders.CSP_NONCE_PATH) {
        var nonce = getCspNonce(dataPlaceholders.CSP_NONCE_PATH);
        if (nonce) {
          t.nonce = nonce;
        }
      }
      t.charset = 'UTF-8';
      document.body.appendChild(t);
    },
    kampyleLoadLogger: function () {

    },
    kampyleEventHandler: function (elem, eventType, handler) {
      if (elem.addEventListener) {
        elem.addEventListener(eventType, handler, false);
      } else if (elem.attachEvent) {
        elem.attachEvent('on' + eventType, handler);
      }
    },

    isSupported: function () {
      var trident = window.KAMPYLE_EMBED.getUserAgent().match(/Trident\/(\d+)/);
      var msie = navigator.userAgent.match(/MSIE (\d+)/);

      return !(trident || msie);
    },

    getUserAgent: function () {
      return navigator.userAgent;
    },

    getGenericLocation: function () {
      var genericLocation = location.protocol + '//' + dataPlaceholders.JS_SITE_CODE;
      if (modulesConfig.isOnPremEnabled) {
        var genericPath = (genericLocation.match(genericPathRegex) || [])[0];
        genericLocation = window.KAMPYLE_EMBED.getResourcesPrefix() + genericPath;
      }
      return genericLocation;
    },

    getOnsiteDataLocation: function (isDhh) {
      var onsiteDataLocation = location.protocol + '//' + dataPlaceholders.ONSITE_DATA_PATH;
      if (modulesConfig.isOnPremEnabled && !isDhh) {
        var onsiteDataPath = (onsiteDataLocation.match(onsiteDataPathRegex) || []) [0];
        onsiteDataLocation = window.KAMPYLE_EMBED.getResourcesPrefix() + onsiteDataPath;
      }
      return onsiteDataLocation;
    },

    getResourcesPrefix: function () {
      if (modulesConfig.isOnPremEnabled) {
        if (window.MDIGITAL_ON_PREM_PREFIX) {
          return window.MDIGITAL_ON_PREM_PREFIX;
        }
        var scripts = document.getElementsByTagName('script');
        var neededSrcPath = null;
        var i = 0;

        while (scripts && !neededSrcPath && i < scripts.length) {
          if (scripts[i].src && onPremEmbedRegex && onPremEmbedRegex.test(scripts[i].src)) {
            neededSrcPath = scripts[i].src;
          }
          i++;
        }

        if (neededSrcPath) {
          window.MDIGITAL_ON_PREM_PREFIX = neededSrcPath.replace(onPremEmbedRegex, '');
          return window.MDIGITAL_ON_PREM_PREFIX;
        }
        if (window.location && window.location.origin) {
          return window.location.origin;
        }
        return '';
      }
    }

  };

  //No support for all IE version-
  if (window.KAMPYLE_EMBED.isSupported()) {
    //check if the page is already loaded
    if (document.readyState === 'complete') {
      window.KAMPYLE_EMBED.kampyleInit();
    } else {
      window.KAMPYLE_EMBED.kampyleEventHandler(window, 'load', window.KAMPYLE_EMBED.kampyleInit);
    }
  }
}
